import { render } from "./App.vue?vue&type=template&id=0c6c8902"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0c6c8902&lang=css"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/modules/iframeCovid/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c6c8902"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c6c8902', __exports__)) {
    console.log('reload')
    api.reload('0c6c8902', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=0c6c8902", () => {
    console.log('re-render')
    api.rerender('0c6c8902', render)
  })

}


export default __exports__